export default __webpack_public_path__ + "0110797797f70017aa6dfc91f5328bff.svg";